import { BaseResourceModel } from '../../models/base-resource.model';
import { ParcelamentoRPPS } from './parcelamento-rpps.model';

export class ParcelamentoPagaRPPS extends BaseResourceModel {
  constructor(
    public numero_parcela?: number,
    public parcelamento_rpps?: ParcelamentoRPPS,
  ) {
    super();
  }
  static converteJson(json: any): ParcelamentoPagaRPPS {
    return Object.assign(new ParcelamentoPagaRPPS(), json);
  }
}